import { ParentCategoryInfo, WidgetSetting } from './Types'
import CategoryMenu, { MenuQuicklink } from './categoryMenu'
import { FunctionalComponent } from 'preact'
import TrackingLink from '../link/tracking-link'
import { UserModel } from '../../server-middleware/userContext'
import { Module } from '../../services/modules'

interface TrackedCategoryMenuProps {
  item: WidgetSetting
  categories: ParentCategoryInfo[]
  popupName: 'community-categories' | 'knowledgebase-categories'
  quickLinks: Array<MenuQuicklink|null>
  openOnHover: boolean
}

const TrackedCategoryMenu: FunctionalComponent<TrackedCategoryMenuProps> = ({ item, categories, popupName, quickLinks, openOnHover }) => {
  return (
    <TrackingLink
      tag='li'
      className='header-navigation_list-item main-menu'
      track={{
        type: `Mega Menu click on ${item.key} module`,
        event_source: 'control'
      }}
    >
      <CategoryMenu
        openOnHover={openOnHover}
        name={item.name}
        popupName={popupName}
        categories={categories}
        quickLinks={quickLinks}
      />
    </TrackingLink>
  )
}

interface Props {
  user: UserModel
  items: WidgetSetting[]
  modules: Module[]
  communityCategories: ParentCategoryInfo[]
  knowledgeBaseCategories: ParentCategoryInfo[]
  className: string
  openOnHover: boolean
}

const MegaMenuLinks: FunctionalComponent<Props> = ({ className, items, user, communityCategories, knowledgeBaseCategories, modules, openOnHover }) => {
  const firstLink: MenuQuicklink = modules?.includes('CommunityOverviewOpenForAllUsers')
    ? {
        url: '/community',
        phrase: { m: 'Forum', p: 'nav.title.community.overview' }
      }
    : {
        url: '/',
        phrase: { m: 'Common', p: 'nav.title.forum.overview' }
      }

  const categoryQuickLinks: Array<MenuQuicklink|null> = [firstLink, {
    url: '/search/activity/recent',
    phrase: { m: 'Common', p: 'nav.title.forum.recent.activity' }
  }, (user.id)
    ? {
        url: '/search/activity/sincelastvisit',
        phrase: { m: 'Common', p: 'nav.title.forum.activity.last.visit' }
      }
    : null, {
    url: '/search/activity/unanswered',
    phrase: { m: 'Common', p: 'nav.title.forum.unanswered.questions' }
  }]
  const knowledgeBaseQuickLinks: Array<MenuQuicklink|null> = [{
    url: '/knowledge-base',
    phrase: { m: 'Forum', p: 'nav.title.knowledgebase' }
  }]

  return (
    <ul className={className}>
      {
       items.map((item) => {
         if (item.key === 'community') {
           return (
             communityCategories.length > 0 && (
               <TrackedCategoryMenu
                 openOnHover={openOnHover}
                 item={item}
                 categories={communityCategories}
                 popupName='community-categories'
                 quickLinks={categoryQuickLinks}
               />
             ))
         } else if (item.key === 'knowledgeBase') {
           return (
             knowledgeBaseCategories.length > 0 && <TrackedCategoryMenu
               openOnHover={openOnHover}
               item={item}
               categories={knowledgeBaseCategories}
               popupName='knowledgebase-categories'
               quickLinks={knowledgeBaseQuickLinks}
                                                   />)
         } else {
           return (
             <li className='header-navigation_list-item'>
               <TrackingLink
                 track={{
                   type: `Mega Menu click on ${item.key} module`,
                   event_source: 'control'
                 }}
                 className={`header-navigation_link title-${item.name.split(' ').join('-').toLowerCase()}`}
                 href={item.url}
                 target={item.external ? '_blank' : ''}
                 rel='noreferrer'
               >{item.name}</TrackingLink>
             </li>
           )
         }
       })
      }
    </ul>
  )
}

export default MegaMenuLinks
